import { Component } from "react"

/* Constants */
import { env } from "../../constants"


/* Widget Preview — the notification as the phone draws it. The same card stands in the form
   while the text is being written, in the card of the template and over the list of recipients,
   so what the admin sees is always what the client will see */
class Preview extends Component {

    render = () => {

        /* Fields */
        const { title, description, button, buttonColor, image, dark } = this.props

        return (
            <div className={`nt-preview ${dark ? "dark" : ""}`}>

                <div className="nt-preview-card">

                    <div className="nt-preview-head">
                        <img className="nt-preview-logo" src="/images/logo.png" alt="Bookify" />
                        <span className="nt-preview-app">Bookify</span>
                        <span className="nt-preview-time">сейчас</span>
                    </div>

                    <div className={`nt-preview-title ${title ? "" : "empty"}`}>
                        {title ? title : "Заголовок уведомления"}
                    </div>

                    <div className={`nt-preview-message ${description ? "" : "empty"}`}>
                        {description ? description : "Текст, который увидит человек в телефоне"}
                    </div>

                    {image &&
                        <img className="nt-preview-image" src={`${env.mediapoint}notifications/${image}`} alt="Notification" />
                    }

                    {button &&
                        <div className="nt-preview-button" style={{ background: buttonColor ? buttonColor : "#0279fc" }}>{button}</div>
                    }

                </div>

            </div>
        )
    }
}

export default Preview
